import "./app.css";
import { initTocAccordion } from "./js/common";
import { initLogoLoader } from "./js/loader";

document.addEventListener("DOMContentLoaded", () => {
	initLogoLoader();
	initTocAccordion();
});
